import React from "react";
import { Row, Col } from "react-bootstrap";
import "./CreateBar.css";

function CreateBar(props) {
  const progressStyle = {
    width: props.percentage + "%",
    backgroundColor: props.color
  };
  return (
    <div className="sss-bars-div">
      <Row>
        <Col xs={3} className="domain-id-col">
          <p>{props.domainName}</p>
        </Col>
        <Col>
          <div className="bar-bg">
            <div className="bar-progress" style={progressStyle}>
              {Math.floor(props.percentage)}%
            </div>
          </div>
        </Col>
      </Row>
    </div>
  );
}

export { CreateBar };